import { render, staticRenderFns } from "./WithdrawalPointFormModal.vue?vue&type=template&id=af44531c&scoped=true&"
import script from "./WithdrawalPointFormModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawalPointFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af44531c",
  null
  
)

export default component.exports